import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ParticipanteService } from '../participantes/participante.service';
import { AuthAndACLService } from '../auth_and_acl/authAndACL.service';
import { Utils } from './../shared/utils';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  providers: [ParticipanteService, Utils]
})
export class HomeComponent implements OnInit {

  public titulo: string = "Sistema de Certificados e Documentos";
  public cpf: string;
  public tipo_pesquisa: string = 'cpf';
  public certificados: any;
  public busy: Promise<any>;
  public startDate: string;
  public endDate: string;

  constructor(public authAndACL: AuthAndACLService, public participanteService: ParticipanteService, public utils: Utils, public flashMessagesService: FlashMessagesService) { }

  pesquisar():void{
    let cpf: string = this.cpf.replace(/[\.-]/g, "");
    this.certificados = [];

    if(this.tipo_pesquisa == "cpf"){
      if(cpf.length != 11 || !this.utils.ValidarCPF(cpf)){
        this.flashMessagesService.show('Informe um CPF válido.', { cssClass: 'card alert-warning', timeout: 5000 });
        return;
      }
    }

    let params: any;

    if(this.tipo_pesquisa == "cpf"){
      params = {tipo_documento: 'cpf', numero_documento: cpf}
    } else if(this.tipo_pesquisa == "passaporte"){
      params = {tipo_documento: 'passaporte', numero_documento: cpf}
    } else if(this.tipo_pesquisa == "nome"){
      params = {nome: cpf}
    }

    if(this.startDate && this.endDate){
      params.criado_em_from = this.startDate;
      params.criado_em_to = this.endDate;
    }

    this.busy = this.participanteService.getTodosCertificadosPorCPF(params)
        .then((response) => this.certificados = response)
        .catch((error) => console.log("aqui"));

  }


  mCPF(): void{
    if(this.tipo_pesquisa == "cpf"){
	   this.cpf=this.cpf.replace(/\D/g,"");
     this.cpf=this.cpf.replace(/(\d{3})(\d)/,"$1.$2");
     this.cpf=this.cpf.replace(/(\d{3})(\d)/,"$1.$2");
     this.cpf=this.cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
    }
  }


  tipoPesquisa(tipo: string): void{
    this.tipo_pesquisa = tipo;
    this.cpf = "";
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts